import { ReactNode } from 'react'
import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'
import PlayIcon from '@/images/PlayIcon'
import { showInDesktop } from '@/styles/mediaQueries'

export interface IWhiskerLabel {
  className?: string
  children: ReactNode
  color?: string
}

const WhiskerLabel = ({ children, className, color }: IWhiskerLabel) => (
  <Wrapper className={className}>
    <Wishker>
      <TriangleLeft color={color} />
      <Line color={color} />
      <TriangleRight color={color} />
    </Wishker>
    {children && (
      <Text color={color}>
        <Highlight>{children}</Highlight>
      </Text>
    )}
  </Wrapper>
)

const Wishker = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`

export const Text = styled.span`
  margin-left: -100%;
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: ${({ color }) => color};
  ${showInDesktop}
`
const Highlight = styled.span`
  background-color: white;
  padding: ${spaces.xs} ${spaces.xs};
`

const TriangleLeft = styled(PlayIcon)<{ color?: string }>`
  width: 8px;
  height: 8px;
  margin-right: -2px;
  path {
    fill: ${({ color }) => color};
  }
`
const TriangleRight = styled(TriangleLeft)`
  transform: rotate(180deg);
  margin-left: -2px;
`

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ color }) => color || 'black'};
`

export default WhiskerLabel
